import React, { useState } from "react";
import "./Header.css";
import { NavLink } from "react-router-dom";
import { settings } from "../../portfolio.js";
import { CgSun } from "react-icons/cg/";
import { HiMoon } from "react-icons/hi";

function Header(props) {
  const theme = props.theme;
  const link = settings.isSplash ? "/splash" : "/home";
  const [currTheme, setCurrTheme] = useState(props.theme);

  function changeTheme() {
    if (currTheme.name === "light") {
      props.setTheme("dark");
      localStorage.setItem("theme", "dark");
      setCurrTheme({ name: "dark" });
    } else {
      props.setTheme("light");
      localStorage.setItem("theme", "light");
      setCurrTheme({ name: "light" });
    }
  }

  const icon =
    props.theme.name === "dark" ? <CgSun size={20} /> : <HiMoon size={20} />;

  const navItems = [
    { path: "/home", label: "Home" },
    { path: "/education", label: "Education" },
    { path: "/experience", label: "Experience" },
    { path: "/projects", label: "Projects" },
    { path: "/contact", label: "Contact" },
  ];

  const headerStyle = {};

  const logoStyle = {
    color: theme.text,
  };

  const menuLinkStyle = {
    color: theme.text,
  };

  const themeToggleBtnStyle = {
    color: theme.text,
  };

  return (
    <header
      className={`header ${theme.name === "light" ? "light" : ""}`}
      style={headerStyle}
    >
      <NavLink to={link} className="logo" style={logoStyle}>
        <div className="logo-text">
          <span className="logo-j">j</span>
          <span className="logo-eeva">eeva</span>
          <span className="logo-dot">.</span>
          <span className="logo-t">t</span>
          <span className="logo-paren">()</span>
        </div>
      </NavLink>
      <ul className="menu">
        {navItems.map((item) => {
          return (
            <li key={item.path}>
              <NavLink
                to={item.path}
                activeClassName="active"
                style={menuLinkStyle}
              >
                <span className="menu-link-text">{item.label}</span>
              </NavLink>
            </li>
          );
        })}
      </ul>
      <button
        className="theme-toggle-btn"
        onClick={changeTheme}
        style={themeToggleBtnStyle}
      >
        {icon}
      </button>
    </header>
  );
}

export default Header;
